import React, { Fragment } from "react";
import CreateAuctionConatiner from "../../containers/upload/createAuctionConatiner";
import Header from "../../components/header";
import { nbfcLogoutRequest, nbfcLogoutSuccess } from "../../store/actions/logOutAction";
import { useDispatch } from "react-redux";

const CreateAuctionPage = () => {
    const dispatch =  useDispatch();

    const logout = () => {
        dispatch(nbfcLogoutRequest());
        dispatch(nbfcLogoutSuccess());
      }

    return (
        <Fragment>
            <Header>
                <Header.MaxWidth>
                <Header.Logo src="../assets/title/Tractor world Logo.svg" alt="Logo" />
                <button onClick={() => logout()}  style={{display:'flex',alignItems:'center', cursor:'pointer', marginLeft:'auto',padding: '10px', borderRadius: '4px', background: '#FFF4E7', color: '#F37021', fontWeight:'700' }}>Logout</button>
                </Header.MaxWidth>
            </Header>
            <CreateAuctionConatiner />
        </Fragment>

    )
}

export default CreateAuctionPage;